import styled from "styled-components";

export const Container = styled.div`
  margin-top: 50px;
  display: flex;
  flex-direction: row;
`;

export const LeftSideBar = styled.div`
  margin-bottom: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 100px;
  align-items: flex-start;
  gap: 20px;
  margin-top: 20px;
  max-height: 900px;
  overflow: scroll; 
  `;
export const VerticalLine = styled.div`
  height: 800px;
  border-right: 1px solid #00000029;
  box-shadow: 2px #00000029;
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  flex-basis: 27%;
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 65%;
  margin-bottom: 20px;
`;

export const InnerRightContainer = styled.div`
  padding: 30px 0px 0px 35px;
`;

export const Card = styled.div`
  min-width: 110vh;
  box-shadow: 0px 3px #00000029;
  border: 1px solid #00000029;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 8px #00000029;
  border-radius: 5px;
  opacity: 1;
`;

export const CardHeading = styled.p`
  font-size: 22px;
  font-family: Poppins-Regular;
  text-align: left;
  line-height: 50px;
  color: #1d1d1d;
  margin: 0;
`;
export const CardInner = styled.div`
  padding: 10px 30px 10px;
  display: flex;
  gap: 25px;
`;

export const ImagesContainer = styled.div`
  margin-top: 30px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  /* sane box-sizing */
  html {
    box-sizing: border-box;
  }
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
`;
export const Heading = styled.div`
  font-size: 30px;
  font-family: "Poppins-Light";
  :hover {
    cursor: pointer;
  }
`;

export const Title = styled.p`
  font-size: 20px;
  font-family: Poppins-Light;
  line-height: 30px;
  color: #1d1d1d;
  margin: 0;
`;

export const InnerCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
`;

export const InnerCardRightContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;
